// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"my-deal-alerts-link_uk-open__xMhv2","grecaptcha-badge":"my-deal-alerts-link_grecaptcha-badge__y6jk6","root":"my-deal-alerts-link_root__YFe5X"};
    if(module.hot) {
      // 1793877058547
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  